import React from 'react';
import './PropertyCard2.css';
import MainBtn from './Btn';
import { Link } from 'react-router-dom';
import PropertyItem from './PropertyItem';
import itemIcon1 from '../../Assets/Icons/itemIcon1.svg';
import itemIcon2 from '../../Assets/Icons/itemIcon2.svg';
import itemIcon3 from '../../Assets/Icons/itemIcon3.svg';

const PropertyCard2 = (props) => {
    return ( 
        <>
        <div className="propertyCard2">
            <div className="propertyCardLeft">
                <div className="extraImgs">
                    <img src={props.extraImg1} alt="alternate imgs" />
                    <img src={props.extraImg2} alt="alternate imgs" />
                    <img src={props.extraImg3} alt="alternate imgs" />
                </div>
                <img className='propMainImg' src={props.propertyImg} alt="Property img" />
            </div>
            <div className="propertyDetails2">
                <h3>{props.propertyTitle}</h3>
                <h5>{props.propertyDescription}</h5>
                <div className="propertyItems">
                    <PropertyItem itemIcon={itemIcon1} itemValue={props.bedValue} />
                    <PropertyItem itemIcon={itemIcon2} itemValue={props.bathValue} />
                    <PropertyItem itemIcon={itemIcon3} itemValue={props.areaValue} />
                </div>
                <Link className='link width100' to="/Details">
                    <MainBtn btnText="MORE DETAILS" btnStyle="detailsBtn" />
                </Link>
            </div>
        </div>
        </>
     );
}
 
export default PropertyCard2;